import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107049Status: 'idle',
    startProcess107049Error: undefined as any,
    loadUserParamsProcess107049Status: 'idle',
    loadUserParamsProcess107049Error: undefined as any,

    process107049List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107049 = createAsyncThunk('process107049Slice/startProcess107049', async ({ process107049 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107049/`,
        prepareData(process107049),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107049Status } = getState().process107049Slice
        return startProcess107049Status !== 'pending'
    }
})

export const loadUserParamsProcess107049 = createAsyncThunk('process107049Slice/loadUserParamsProcess107049', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107049/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107049Status } = getState().process107049Slice
        return loadUserParamsProcess107049Status !== 'pending'
    }
})

const Process107049Slice = createSlice({
    name: 'process107049Slice',
    initialState,
    reducers: {
        resetstartProcess107049: (state) => {
            state.job = undefined
            state.startProcess107049Error = undefined
        },
        resetstartProcess107049Error: (state) => {
            state.startProcess107049Error = undefined
        },
        resetloadUserParamsProcess107049: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107049Error = undefined
        },
        resetloadUserParamsProcess107049Error: (state) => {
            state.loadUserParamsProcess107049Error = undefined
        },
        removeFromProcess107049ListById: (state, action) => {
            state.process107049List = state.process107049List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107049ListByIds: (state, action) => {
            state.process107049List = state.process107049List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107049List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107049Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107049List = []
            state.startProcess107049Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107049.pending, (state) => {
            state.startProcess107049Status = 'pending'
            state.startProcess107049Error = undefined
        })
        builder.addCase(startProcess107049.fulfilled, (state, action) => {
            state.startProcess107049Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107049.rejected, (state, action) => {
            state.startProcess107049Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107049Error = action.error.message
            } else {
                state.startProcess107049Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107049.pending, (state) => {
            state.loadUserParamsProcess107049Status = 'pending'
            state.loadUserParamsProcess107049Error = undefined
        })
        builder.addCase(loadUserParamsProcess107049.fulfilled, (state, action) => {
            state.loadUserParamsProcess107049Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107049.rejected, (state, action) => {
            state.loadUserParamsProcess107049Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107049Error = action.error.message
            } else {
                state.loadUserParamsProcess107049Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107049,
    resetstartProcess107049Error,
    resetloadUserParamsProcess107049,
    resetloadUserParamsProcess107049Error,
    removeFromProcess107049ListById,
    removeFromProcess107049ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107049Slice.actions
export default Process107049Slice.reducer
